export const MERIDIEMS = ["AM", "PM"] as const;

export type MeridiemType = (typeof MERIDIEMS)[number];

export type LanguageCodes = "en" | "es" | "zh";

export interface MessageTemplateTranslations {
  readonly language_code: LanguageCodes;
  readonly content: string;
  readonly content_raw: string;
}

export const ExpressionAndType = "and_";
export const ExpressionAnyType = "any_";
export const ExpressionDataType = "data_";
export const ExpressionOrType = "or_";
export const ExpressionFuncType = "func";
export const ExpressionContextType = "context";
export const MultipleBooleanExpressionTypes = [
  ExpressionAndType,
  ExpressionAnyType,
  ExpressionDataType,
  ExpressionOrType,
  ExpressionFuncType,
  ExpressionContextType,
] as const;

export type ExpressionType = (typeof MultipleBooleanExpressionTypes)[number];

export interface ContextExpression {
  args?: string[];
  type?: typeof ExpressionContextType;
}

export interface ExpressionList extends Array<Expression> {
  args?: Expression[] | Expression;
}

export interface ExpressionArgs {
  args?: Expression[] | Expression;
  type?: ExpressionType;
}

export interface LookbackArgs {
  created_at?: string | ContextExpression;
  lookback_value?: string | number;
  received_at?: string | ContextExpression;
  time_unit?: string;
}

export interface FuncExpressionValue {
  kwargs?: LookbackArgs;
  name?: string;
  type?: ExpressionType;
}

export type ExpressionValue = (Expression | FuncExpressionValue | string[] | string | boolean | number | null) & { kwargs?: LookbackArgs };

export interface Expression {
  args?: ExpressionArgs | ExpressionList | Expression;
  field?: string;
  kwargs?: Record<string, unknown>;
  model?: string;
  name?: string;
  op?: string;
  type?: ExpressionType;
  value?: ExpressionValue;
}
